import _createClass from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { getChannels } from './packing_util';
import { getCoordsDataType } from './shader_compiler';
export var PadPackedProgram = /*#__PURE__*/_createClass(function PadPackedProgram(xShape, paddings, constantValue) {
  _classCallCheck(this, PadPackedProgram);
  this.variableNames = ['x'];
  this.packedInputs = true;
  this.packedOutput = true;
  this.outputShape = paddings.map(function (p, i) {
    return p[0] /* beforePad */ + xShape[i] + p[1];
  } /* afterPad */);
  var rank = xShape.length;
  var dtype = getCoordsDataType(rank);
  var start = paddings.map(function (p) {
    return p[0];
  }).join(',');
  var end = paddings.map(function (p, i) {
    return p[0] + xShape[i];
  }).join(',');
  var coords = getChannels('rc', rank);
  var source = getChannels('source', rank);
  var cLimit = "".concat(coords[rank - 1], " < ").concat(this.outputShape[rank - 1]);
  var innerDims = rank === 1 ? 'source' : "vec2(".concat(source.slice(-2).join(), ")");
  var componentSetup = ["".concat(dtype, " rc = outputLoc;"), "".concat(coords[rank - 1], " += 1;\n       if(").concat(cLimit, ") {\n      "), rank === 1 ? '' : "}\n       rc = outputLoc;\n       ".concat(coords[rank - 2], " += 1;\n       if(").concat(coords[rank - 2], " < ").concat(this.outputShape[rank - 2], ") {"), rank === 1 ? '' : "  ".concat(coords[rank - 1], " += 1;\n         if(").concat(cLimit, ") {")];
  var paddingArea = rank === 1 ? 'rc < start || rc >= end' : 'any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))';
  var mainLoop = '';
  for (var i = 0, j = rank === 1 ? 2 : 4; i < j; i++) {
    mainLoop += "\n        ".concat(componentSetup[i], "\n        if (").concat(paddingArea, ") {\n          result[").concat(i, "] = float(").concat(constantValue, ");\n        } else {\n          ").concat(dtype, " source = rc - start;\n          result[").concat(i, "] = getChannel(getX(").concat(source.join(), "), ").concat(innerDims, ");\n        }\n      ");
  }
  mainLoop += rank === 1 ? "} " : "}}";
  this.userCode = "\n      const ".concat(dtype, " start = ").concat(dtype, "(").concat(start, ");\n      const ").concat(dtype, " end = ").concat(dtype, "(").concat(end, ");\n\n      void main() {\n        ").concat(dtype, " outputLoc = getOutputCoords();\n        vec4 result = vec4(0.);\n        ").concat(mainLoop, "\n        setOutput(result);\n      }\n    ");
});